import { call, put, all, takeLatest, cancelled } from "redux-saga/effects";
import { Api } from "../api";
import * as auditActions from "../actions/audit";
import * as authActions from "../actions/auth";
import { cancelable } from "./cancel";

function* getAuditLookups(action) {
  try {
    const res = yield call(Api.audit.getAuditLookups, action.payload);
    yield put({
      type: auditActions.GET_AUDIT_LOOKUPS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put({
      type: auditActions.GET_AUDIT_LOOKUPS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally {
    if (yield cancelled()) {
      console.log('getAuditLookups cancelled');
    }
  }
}

function* getAuditQualitySummaryData(action) {
  try {
    const res = yield call(Api.audit.getAuditQualitySummaryData, action.payload);
    yield put({
      type: auditActions.GET_AUDIT_QUALITY_SUMMARY_DATA_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put({
      type: auditActions.GET_AUDIT_QUALITY_SUMMARY_DATA_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally {
    if (yield cancelled()) {
      console.log('getAuditQualitySummaryData cancelled');
    }
  }
}

function* getUnAssignedIncidents(action) {
  console.log('getUnAssignedIncidents called',action.payload.Size);
  try {
    const res = yield call(action.payload.selectedTab === "unassigned" ? Api.audit.getUnAssignedIncidents : Api.audit.getAssignedIncidents, action.payload);
    if(action.payload.Size > 1000)
      yield put({
        type: auditActions.GET_ALL_INCIDENTS_SUCCESS,
        payload: res.data,
      });
    else
      yield put({
        type: auditActions.GET_UNASSIGNED_INCIDENTS_SUCCESS,
        payload: res.data,
      });
  } catch (err) {
    if(action.payload.Size > 1000)
      yield put({
        type: auditActions.GET_ALL_INCIDENTS_FAIL,
        payload: { error: err.message },
        });
    else
    yield put({
      type: auditActions.GET_UNASSIGNED_INCIDENTS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally {
    if (yield cancelled()) {
      console.log('getUnAssignedIncidents cancelled');
    }
  }
}

function* getAuditDetails(action) {
  try {
    const res = yield call(Api.audit.getAuditTaskDetails, action.payload);
    yield put({
      type: auditActions.GET_AUDIT_DETAILS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put({
      type: auditActions.GET_AUDIT_DETAILS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally {
    if (yield cancelled()) {
      console.log('getAuditDetails cancelled');
    }
  }
}


export default all([
  takeLatest(auditActions.GET_AUDIT_LOOKUPS_REQUEST, function* (action) {
    yield call(cancelable, getAuditLookups, action);
  }),
  takeLatest(auditActions.GET_AUDIT_QUALITY_SUMMARY_DATA_REQUEST, function* (action) {
    yield call(cancelable, getAuditQualitySummaryData, action);
  }),
  takeLatest(auditActions.GET_UNASSIGNED_INCIDENTS_REQUEST, function* (action) {
    yield call(cancelable, getUnAssignedIncidents, action);
  }),
  takeLatest(auditActions.GET_ALL_INCIDENTS_REQUEST, function* (action) {
    yield call(cancelable, getUnAssignedIncidents, action);
  }),
  takeLatest(auditActions.GET_AUDIT_DETAILS_REQUEST, function* (action) {
    yield call(cancelable, getAuditDetails, action);
  }),
  ]
);
